/**
v1.0.0

*/

class EventsManage {
  constructor() {
    this._event_list = [] //事件记录
  }

  /**
   添加句柄(element:元素，type:事件类型，handler:事件处理函数)
   */
  addEventListener(element, type, handler) {
    if (element.addEventListener) {
      element.addEventListener(type, handler, false)
    } else if (element.attachEvent) {
      element.attachEvent('on' + type, handler)
    } else {
      //DOM0级事件处理程序的判断
      element['on' + type] = handler
    }

    this._event_list.push([element, type, handler])

    // console.log("addEventListener:" + this._event_list.length, type);
  }

  /**
   添加句柄(element:元素，type:事件类型，handler:事件处理函数)
   */
  removeAllEventListener() {
    var len = this._event_list.length
    console.log('removeAllEventListener:' + len)
    while (this._event_list.length > 0) {
      let eventArray = this._event_list.pop()
      this.removeEventListener(eventArray[0], eventArray[1], eventArray[2])
    }
  }

  /**
   添加句柄(element:元素，type:事件类型，handler:事件处理函数)
   */
  removeEventListener(element, type, handler) {
    if (element.removeEventListener) {
      element.removeEventListener(type, handler, false)
    } else if (element.detachEvent) {
      element.detachEvent('on' + type, handler)
    } else {
      //DOM0级事件处理程序的判断
      element['on' + type] = null
    }
  }
}

export default EventsManage
